import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

// Presets first: making someone open a date picker for "in a month" is
// the friction that kills follow-ups.
const PRESET_DAYS = [
  { key: 'week', days: 7 },
  { key: 'twoWeeks', days: 14 },
  { key: 'month', days: 30 },
  { key: 'quarter', days: 90 },
];

const inDays = (days) => {
  const date = new Date();
  date.setDate(date.getDate() + days);
  return date;
};

export default function LeadStatusPicker({ statuses, value, onApply, disabled, compact }) {
  const { t } = useTranslation('common');
  const [pending, setPending] = useState(null);
  const [customDate, setCustomDate] = useState('');
  const [error, setError] = useState(null);

  const apply = async (status, followUpAt) => {
    setError(null);
    try {
      await onApply({ pipelineStatus: status.key, followUpAt: followUpAt ? followUpAt.toISOString() : null });
      setPending(null);
      setCustomDate('');
    } catch (e) {
      setError(e?.response?.data?.detail || e.message);
    }
  };

  const choose = (key) => {
    const status = statuses.find((s) => s.key === key);
    if (!status) return;
    if (status.requires_date) {
      setPending(status);
      return;
    }
    apply(status, null);
  };

  return (
    <span className="lead-status-picker">
      <select
        className={compact ? 'lead-status-select lead-status-select-compact' : 'lead-status-select'}
        value={value || ''}
        disabled={disabled}
        onChange={(e) => choose(e.target.value)}
      >
        {statuses.map((status) => (
          <option key={status.key} value={status.key}>
            {status.name}
          </option>
        ))}
      </select>

      {pending && (
        <span className="lead-followup-presets">
          {PRESET_DAYS.map((preset) => (
            <button key={preset.key} className="unibox-page-button" onClick={() => apply(pending, inDays(preset.days))}>
              {t(`outreach.leads.followUp.${preset.key}`)}
            </button>
          ))}
          <input
            type="date"
            className="lead-status-select"
            value={customDate}
            onChange={(e) => setCustomDate(e.target.value)}
          />
          <button
            className="unibox-page-button"
            disabled={!customDate}
            onClick={() => apply(pending, new Date(`${customDate}T09:00:00`))}
          >
            {t('outreach.leads.followUp.apply')}
          </button>
          <button className="unibox-page-button" onClick={() => setPending(null)}>
            {t('outreach.close')}
          </button>
        </span>
      )}

      {error && <span className="unibox-error">{String(error)}</span>}
    </span>
  );
}
